module.exports = __webpack_public_path__ + "static/media/manwithmail.3509b4d7.png";